import { render, staticRenderFns } from "./QuoteColumns.vue?vue&type=template&id=93362b74&scoped=true"
import script from "./QuoteColumns.vue?vue&type=script&lang=js"
export * from "./QuoteColumns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93362b74",
  null
  
)

export default component.exports